import React from "react";

export default function History_Jobs() {
  return (
    <div>
      <h1>History_Jobs</h1>
      <p>This is the History_Jobs component.</p>
    </div>
  );
}
